import styled from 'styled-components';

import { StyledButton } from '../../../../../common-styles';

export const UiUpdateBonusesButton = styled(StyledButton)`
  height: 100%;
  padding: 7px 28px;
`;
